import serviceLocator from "scripts/ioc/serviceLocator";

export default function(serviceName) {
  return serviceLocator.request(serviceName);
}
